import { vec3 } from "gl-matrix";
import { ShaderType } from "../ShaderManager";

export enum ObjectType {
  UNSPECIFIED,
  CUBE,
  MESH,
  PLANE,
  SPHERE,
};

export function ObjectTypeToString(type: ObjectType): string {
  switch (type) {
    case ObjectType.UNSPECIFIED:
      return "unspecified";
    case ObjectType.CUBE:
      return "cube";
    case ObjectType.MESH:
      return "mesh";
    case ObjectType.PLANE:
      return "plane";
    case ObjectType.SPHERE:
      return "sphere"
    default:
      return "unspecified";
  }
}

export type ObjectBuffers = {
  vao: WebGLVertexArrayObject;
  attributes: {
    position: WebGLBuffer;
    normal?: WebGLBuffer;
    uv?: WebGLBuffer;
    tangents?: WebGLBuffer;
    bitangents?: WebGLBuffer;
  };
  indicies: WebGLBuffer;
  numVertices: number;
}

export type Material = {
  diffuse: vec3;
  ambient: vec3;
  specular: vec3;
  n: number;
  alpha: number;
  shaderType: ShaderType
  diffuseTexture?: { name: string, texture?: WebGLTexture };
  normalTexture?: { name: string, texture?: WebGLTexture };
};

export type ExportedMaterial = {
  diffuse: number[];
  ambient: number[];
  specular: number[];
  n: number;
  alpha: number;
  shaderType: number;
  diffuseTexture?: { name: string };
  normalTexture?: { name: string };
}

export const defaultMaterial: Material = {
  diffuse: vec3.fromValues(0.5, 0.5, 0.5),
  ambient: vec3.fromValues(0.1, 0.1, 0.1),
  specular: vec3.fromValues(0.1, 0.1, 0.1),
  n: 12,
  alpha: 1,
  shaderType: ShaderType.BASIC,
}
